export * from './actions';
export * from './effects';
export * from './service';

export {
  featureKey as validateFiscalCodeKey,
  initialState as validateFiscalCodeInitialState,
  State as ValidateFiscalCodeState,
} from './reducer';

export {
  getData as validateFiscalCodeGetData,
  getError as validateFiscalCodeGetError,
  getLoading as validateFiscalCodeGetLoading,
  mapData as validateFiscalCodeMapData,
} from './selectors';
